module.exports = __webpack_public_path__ + "media/images/Flexibility Stacked-a5d08b7c.png";